<template>
  <div class="ms-combobox-tree ms-editor" :class="[{'ms-validate': true}]">
    <div v-if="title && showTitle" class="combo-title flex">
      <div class="combo-title__text">{{ title }}</div>
    </div>
    <label v-if="label" :title="title" class="label">{{ label }}</label>
    <div
      class="flex-row combo-box-input"
      :class="[{error: errorMessage, disabled: disabled}, hasBorder ? 'border' : '']"
    >
      <div v-if="leftIcon" :class="['icon24 left-icon', leftIcon]"></div>
      <!-- TODO => Thêm các prop để show tooltip -->
      <input
        ref="input"
        v-model="internalText"
        :title="internalText"
        class="input flex"
        :placeholder="placeholder"
        :disabled="disabled"
        :readOnly="readOnly || selectOnly"
        :maxlength="maxLength"
        :class="{disabled: disabled}"
        v-on="listeners"
        @keydown.esc="onEsc"
        @keydown.enter="onEnter"
        @keydown.f3="quickSearchClick"
        @keydown.f9="showQuickAdd(false, true)"
      />

      <div
        v-if="quickAdd && !isGridEditor"
        class="quickAdd"
        :class="{hide: readOnly || disabled}"
        @click="showQuickAdd"
        @keydown.enter="showQuickAdd"
      ></div>
      <div
        class="icon-combo--dropdown"
        :class="{
          disabled: disabled,
          'point-event-none': readOnly,
          expand: expanded,
        }"
        @click="triggerClick"
      ></div>
      <!-- <div
        v-if="quickSearch && !isGridEditor"
        class="quickSearch"
        @click="quickSearchClick"
        @keydown.enter="quickSearchClick"
        :class="{ hide: readOnly || disabled }"
      ></div> -->
    </div>
    <div v-if="errorMessage && isShowText && !isGridEditor" class="error-text">
      {{ errorMessage }}
    </div>
    <ms-combobox-tree-dropdown
      v-show="expanded"
      ref="dropdownPanel"
      :topx="dropdownTopx"
      :leftx="dropdownLeftx"
      :max-widthx="dropdownMaxWidthx"
      :min-widthx="dropdownMinWidthx"
      :columns="columns"
      :highligh-index="typeAheadPointer"
      :scroll-top="dropdownScrollTop"
      :loading="loading"
      :quick-add="quickAdd"
      :quick-search="quickSearch"
      @add-new="showQuickAdd"
    >
      <ms-combobox-tree-item
        v-for="item in internalDataSource"
        :key="item[valueField]"
        :item="item"
        :columns="columns"
        :value-field="valueField"
        :display-field="displayField"
        :selected-value="modelValue"
        :active-value="activeItem ? activeItem[valueField] : null"
        @item-click="onItemClick"
        @toogle-expand="itemToogleExpand"
      />

      <!-- @mousedown="onItemClick(item, $event)" -->
      <template v-slot:quickSearch>
        <div
          class="quickSearch"
          v-if="quickSearch"
          @click="quickSearchClick"
          @keydown.enter="quickSearchClick"
          :class="{hide: readOnly || disabled}"
        >
          <div class="button icon24 quick-search"></div>
          <div class="txt-quick-search">Tìm nhanh (F3)</div>
        </div>
      </template>
    </ms-combobox-tree-dropdown>
  </div>
</template>
<script>
import {defineComponent, getCurrentInstance} from 'vue';

import MsComboboxTreeDropdown from './MsComboboxTreeDropdown.vue';
import MsComboboxTreeItem from './MsComboboxTreeItem.vue';
import commonFn from '@/commons/commonFunction.js';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';
import _ from 'lodash';
import {filter} from '@/mixins/common/filter';
import {validateCombobox} from '@/mixins/component/validateCombobox';
import {useValidateControl} from '@/composables/validateControl.js';

import popupUtil from '@/commons/popupUtil.js';
export default defineComponent({
  name: 'MsComboboxTree',
  components: {
    MsComboboxTreeDropdown,
    MsComboboxTreeItem,
  },
  extends: msBaseComponent,
  mixins: [filter],
  props: {
    modelValue: {},
    customTooltip: {
      default: null,
      type: [Object],
    },
    placeholder: {
      default: null,
      type: [Number, String],
    },
    maxItemsDisplay: {
      default: 5,
      type: Number,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    /**
     * Trường làm value
     * CreatedBy LTDAT 15.06.2020
     */
    valueField: {
      type: String,
      default: null,
    },
    /**
     * Trường làm text display
     * CreatedBy LTDAT 15.06.2020
     */
    displayField: {
      type: String,
      default: null,
    },
    // Dữ liệu của combobox
    data: {
      default: () => [],
      type: Array,
    },
    // Độ rộng của 1 item
    itemSize: {
      default: 28,
      type: Number,
    },
    // Chỉ nhận giá trị có trong danh sách
    forceSelection: {
      default: true,
      type: Boolean,
    },
    // Là combotree hay không
    isTree: {
      default: false,
      type: Boolean,
    },
    // Parent Field
    idProperty: {
      default: 'id',
      type: String,
    },
    // Field chứa parentID
    parentIdProperty: {
      default: 'parent_id',
      type: String,
    },
    // Không cho phép chọn trường là cha
    notSelectionParent: {
      default: false,
      type: Boolean,
    },
    // Độ rông của dropdown tính bằng px
    dropdownWidth: {
      default: null,
      type: [String, Number],
    },
    // Mode query lấy dữ liệu từ server hay client
    queryMode: {
      type: String,
      default: 'local',
    },
    remoteFilter: {
      type: Boolean,
      default: false,
    },
    // Gán giá trị text lúc ban đầu
    initText: {
      default: null,
      type: [Number, String],
    },
    // chỉ cho phép chọn không cho phép nhập text
    selectOnly: {
      default: false,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    display: {},
    mappingField: {
      default: null,
    },
    firstExpandLoad: {
      default: false,
      type: Boolean,
    },
    keyField: {
      // default: '__vKeyValue',
      type: String,
    },
    maxLength: {
      default: null,
      type: Number,
    },
    leftIcon: {
      type: String,
    },
    /**
     * Câu hình quicksearch
     */
    quickSearch: {
      type: String,
    },
    /**
     * Dữ liệu truyền kèm quicksearch
     */
    quickSearchParam: {
      type: Object,
      default: null,
    },
    /**
     * Câu hình add
     */
    quickAdd: {
      type: String,
      default: null,
    },
    isShowText: {
      type: Boolean,
      default: true,
    },
    // pvduy 17/03/2021: thêm prop rule để có thể custom ở ngoài form
    rules: {
      type: String,
      default: '',
    },
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
    /**
     * Danh sách các trường dữ liệu lấy về
     */
    requestField: {
      type: String,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    /**
     * Danh sách các trường dữ liệu lấy về
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * custom lại tham số filter
     */
    buildFilter: {
      type: Function,
      default: null,
    },

    isReload: {
      type: Boolean,
      default: false,
    },
    /**
     * size paging
     */
    pageSize: {
      type: Number,
      default: 10,
    },
    /**
     * Giá trị bản ghi tất cả
     */
    selectAllValue: {
      type: [Number, String],
      default: -1,
    },
    /**
     * Text hiển thị tất cả
     */
    selectAllText: {
      type: String,
      default: null,
    },
    /**
     * Có hiển thị bản ghi tất cả không
     */
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },

    // Xác định các rule validate
    // Mặc định của combo sẽ là force select
    rules: {
      default: [{name: 'forceSelection'}],
      type: Array,
    },

    // expand node đấu tiền của cây
    // mặc định là không
    isExpandFirstNode: {
      default: false,
      type: Boolean,
    },

    /**
     * Expand tất cả các node
     */
    expandAll: {
      type: Boolean,
      default: false,
    },

    /**
     * Trường làm text hiển thị dạng code - name
     * nddat1 08/10.2024
     */
    suffixDisplayField: {
      type: String,
      default: null,
    },
    /**
     * Trường giá trị ngăn cách
     * nddat1 08/10.2024
     */
    seperateChar: {
      type: String,
      default: '-',
    },
    /**
     * Dữ liệu đang chọn của combobox trước khi mở lần đầu tiên
     * nddat1 08/10.2024
     */
    firstData: {
      type: Object,
      default: null,
    },
  },
  emits: [
    'msKeydown',
    'comboboxLoadData',
    'blur',
    'beforeQuery',
    'autoSelected',
    'update:modelValue',
    'update:display',
    'selected',
    'beforeExpand',
    'change',
    'click',
    'input',
  ],

  setup(props) {
    const {errorMessage, handlerValidateCombobox, getTitleError, clearValidate} = useValidateControl({
      props,
    });
    const {proxy} = getCurrentInstance();
    const validate = () => {
      return handlerValidateCombobox();
    };
    return {errorMessage, validate, getTitleError, clearValidate};
  },
  data() {
    const me = this;
    me.initStaticData();

    window._tr = me;

    return {
      // _allData: [],
      // _allTreeData: [],
      internalDataSource: [],
      internalText: null,
      expanded: false,
      dropdownTopx: 0,
      dropdownLeftx: 0,
      internalSelectedItem: null,
      typeAheadPointer: -1,
      focused: false,
      // ĐVThi  03/03/2021
      // kích thước mặc định của itemSize của combox khi được dùng trên lưới Editor
      gridItemSize: 48,
      tooltipLeft: 0,
      dropdownScrollTop: 0,
      /**
       * Đang load dữ liệu
       */
      loading: false,
      /**
       * Tham số load dữ liệu lần gần nhất
       */
      lastRequestParam: null,
      dropdownMinWidthx: null,
      dropdownMaxWidthx: null,
      /**
       * item đang được target trong dropdown menu
       */
      activeItem: null,
    };
  },
  computed: {
    /**
     * data source cho tooltip
     * created by ntphong 29/5/2021
     */
    tooltipDataSource() {
      const me = this;
      let dataSource = me.internalDataSource;
      if (me._allData && me._allData.length > 0) {
        dataSource = me._allData;
      }
      return dataSource;
    },
    listeners() {
      const me = this;
      return {
        input: event => me.onInput(event),
        focus: event => me.onFocus(event),
        change: event => me.onChange(event),
        blur: event => me.onBlur(event),
        keydown: event => me.onKeydown(event),
        click: event => me.onClick(event),
      };
    },
    // Tính độ rộng của dropdown combobox để scroll
    styleScroller() {
      const me = this;
      return {'max-height': me.maxItemsDisplay * me.itemSize + 'px'};
    },
  },

  watch: {
    data: {
      inmediate: true,
      handler(newVal) {
        const me = this;
        if (me.loading) {
          me.loading = false;

          // Xử lý focus sau khi load xong dữ liệu
          if (me._pendingFocusAfterLoad && me.expanded) {
            me.$nextTick(() => {
              me.activeOnExpand();
              me._pendingFocusAfterLoad = false;
            });
          }
        }

        if (newVal == null) {
          // tình huống có thêm/sửa/xóa dữ liệu gốc -> reset để khi expand sẽ load lại dữ liệu
          me.lastQueryString = new Date().getTime();
          me._allData = null;
        } else {
          if (me.queryMode !== 'remote') {
            me._allData = newVal;
          }

          if (me.internalDataSource != newVal && !(me.internalDataSource.length === 0 && newVal.length === 0)) {
            me.initData();

            // Khi dữ liệu được khởi tạo xong, nếu đang cần focus thì thực hiện
            if (me._pendingFocusAfterLoad && me.expanded) {
              me.$nextTick(() => {
                me.activeOnExpand();
                me._pendingFocusAfterLoad = false;
              });
            }
          }
        }
      },
    },
    /**
     * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
     */
    initText: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (newVal || oldVal) {
          me.setInitText(newVal);
        }
      },
    },

    // //Khi thay đổi số phần tử của combox thì thiết lập lại vị trí của dropdow
    // internalDataSource: {
    //   immediate: true,
    //   handler() {
    //     //ĐVThi sửa lỗi 90491 không thay đổi vị trí khi gõ text để search trên combox
    //     // this.changeDropdownPosition();
    //   },
    // },
  },
  // Hàm khởi tạo dữ liệu hook func
  created() {
    const me = this;
    me.initIndex = 0;

    // me.setInitIndex();
    me.initData();
    if (me.autoLoad) {
      me.doQueryInternal(null, false);
    }
    EventBusGlobal.$on(GlobalEventName.scrollEvent, me.scrollEvent);
    // if (me.mappingField) {
    //   for (let key in me.mappingField) {
    //     me.$options.propsData[key] = null;
    //   }
    // }
    // me.initData();
    // me.setInitText();
  },
  mounted() {
    const me = this;
    // Debounce query để delay load
    if (me.queryMode != 'remote') {
      me.internalQueryDelay = 500;
    }
    me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
    document.addEventListener('click', me.click_out);

    // init alltext
    me._selectAllText = me.selectAllText || me.$t('i18nComponent.Combobox.SelectAllItemText');
  },
  beforeUnmount() {
    const me = this;
    me.collapse();
    if (me.$refs.dropdownPanel) {
      me.$refs.dropdownPanel.$el.remove();
    }
    EventBusGlobal.$off(GlobalEventName.scrollEvent, me.scrollEvent);
    document.removeEventListener('click', me.click_out);
  },
  methods: {
    getTooltipClass() {
      const me = this;
      if (me.$el) {
        me.tooltipLeft = -me.$el.offsetWidth / 2;
      }
      if (me.customTooltip) {
        return 'tooltip-' + me.customTooltip.type.toLowerCase();
      } else {
        return '';
      }
    },
    getValue() {
      const me = this;
      return me.internalText;
    },
    /**
     * kiểm tra xem dữ liệu trên combobox có trống hay không
     * @author tmchi 16.04.2021
     */
    isNullOrEmptyvalue() {
      if (this.modelValue == null || this.modelValue == {}) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Bắt sự kiện khi scroll trên chương trình thì đóng combobox lại
     * Created by LTDAT
     */
    scrollEvent() {
      const me = this;
      if (me.expanded) {
        me.collapse();
      }
    },
    // /**
    //  * Mặc định chọn giá trị theo index ban đầu
    //  * Created by LTDAT
    //  */
    // setInitIndex() {
    //   const me = this;
    //   if (
    //     me.initIndex >= 0 &&
    //     me.internalDataSource &&
    //     me.internalDataSource.length > 0 &&
    //     me.typeAheadPointer < 0
    //   ) {
    //     me.typeAheadPointer = me.initIndex;
    //     me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
    //   }
    // },
    /**
     * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
     * Created by LTDAT(25.06.2020)
     */
    setInitText(val) {
      const me = this;
      me.internalText = me.initText ? me.initText : val;
    },
    /**
     * Tìm item theo text truyền vào
     * DVTHUC 21/02/2024
     */
    findItemByText(queryText) {
      if (!queryText) return false;
      let data = this._allData || [];
      !data.length && (data = this.internalDataSource || []);
      if (!data || data.length === 0) return false;
      return data.filter(item => {
        let text = '';
        if (item[this.suffixDisplayField] && item[this.displayField]) {
          text = `${item[this.suffixDisplayField]} ${this.seperateChar} ${item[this.displayField]}`;
        } else if (item[this.suffixDisplayField]) {
          text = `${item[this.suffixDisplayField]}`;
        } else if (item[this.displayField]) {
          text = `${item[this.displayField]}`;
        }

        if (queryText === text) {
          return item;
        }
      });
    },
    /**
     * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
     * CreatedBy LTDAT 11/12/2019
     */
    doQueryInternal(searchString, expand) {
      const me = this;
      const event = {preventDefault: false, sender: me};
      let queryString = searchString;
      me.$emit('beforeQuery', event);
      if (event.preventDefault) {
        return false;
      }
      if (me.lastQueryString === queryString && !me.isReload) {
        if (expand) {
          me.expand();
        }
      } else {
        me.dropdownScrollTop = 0;
        me.internalDataSource = [];
        me.lastQueryString = queryString;
        me.querying = true;
        // me.typeAheadPointer = -1;
        //PDTAI 20/08/2024: Nếu queryMode là remote thì load lại dữ liệu để có thể phục vụ việc custom lại dữ liệu hiển thị ra
        if (me.queryMode === 'remote') {
          if (me.isTree) {
            queryString = null;
          }
          me.doRemoteQuery(queryString);
          // nddat1 08/10/2024: Nếu truyền vào dữ liệu đầu tiên thì sẽ focus vào dòng đó
          if (me.firstData) {
            me.setActive(me.firstData);
          }
        } else {
          me.$nextTick(() => {
            me.doLocalQuery(queryString);
            if (expand && !me.expanded) {
              me.expand();
            } else {
              // me.doHightlightItem(true);
              // active bản ghi đầu tiên
              me.setActive(me.internalDataSource[0]);
            }
          });
        }
        // me.$props.isReload = false;
      }
    },

    /**
     * Xử lý sau khi query xong dữ liệu
     * CreatedBy LTDAT 24.06.2020
     */
    afterQuery(expand) {
      const me = this;
      if (expand) {
        me.expand();
      }
    },
    /**
     * Query dữ liệu api
     * CreatedBy LTDAT 24.06.2020
     */
    doRemoteQuery(queryString) {
      // Build filter,
      const me = this;
      const filters = [];
      const filterFields = me.filterFields || {};
      return new Promise((resolve, reject) => {
        try {
          if (queryString) {
            const filterQuery = {};
            const fields = Object.keys(filterFields);
            const filter = {
              Field: fields[0],
              Operator: filterFields[fields[0]],
              Value: queryString,
            };
            filters.push(filter);
            if (fields.length > 1) {
              filter.Ors = [];
              for (let i = 1; i < fields.length; i++) {
                filter.Ors.push({
                  Field: fields[i],
                  Operator: filterFields[fields[i]],
                  Value: queryString,
                });
              }
            }
          }
          const payload = {};
          payload.skip = 0;
          payload.take = me.pageSize;
          payload.pageAppend = false;
          if (filters.length > 0) {
            payload.filter = JSON.stringify(filters);
          }

          let columns = [me.displayField, me.valueField];
          if (me.columns && me.columns.length > 0) {
            me.columns.forEach(item => {
              if (item.dataField && columns.indexOf(item.dataField) === -1) {
                columns.push(item.dataField);
              }
            });
          }

          if (me.mappingField) {
            for (const i in me.mappingField) {
              if (columns.indexOf(i) === -1) {
                columns.push(i);
              }
            }
          }

          if (me.requestField) {
            me.requestField.split(',').forEach(item => {
              if (item && columns.indexOf(item)) {
                columns.push(item);
              }
            });
          }
          columns = columns.distinctKey(columns);

          payload.columns = columns.join(',');

          me.lastRequestParam = payload;
          if (typeof me.buildFilter == 'function') {
            me.buildFilter(payload);
          }
          me.loading = true;

          // Đánh dấu cần focus sau khi load data xong
          me._pendingFocusAfterLoad = true;

          if (me.modelValue) {
            Object.assign(payload, {
              selectedItem: JSON.stringify({
                [me.valueField]: me.modelValue,
              }),
            });
          }
          me.$emit(me.$ms.constant.CustomEvent.MsComboboxLoadData, payload);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    /**
     * Query dữ liệu local
     * CreatedBy LTDAT 24.06.2020
     */
    doLocalQuery(queryString) {
      const me = this;
      if (!queryString) {
        // nếu không có text dùng all source đã build khi initData luôn
        me.internalDataSource = me._allTreeData;

        if (me.expandAll) {
          me.expandAllNode();
        } else if (Array.isArray(me.internalDataSource)) {
          // //fix expand with first level
          // for (let i = 0; i < me.internalDataSource.length; i++) {
          //   me.resetExpand(
          //     me.internalDataSource[i],
          //     i < 2 && me.isExpandFirstNode
          //   );
          // }
          // expand all cấp 1 và item đầu tiên của level2
          let expandLv2 = true;
          for (let i = 0; i < me.internalDataSource.length; i++) {
            const item = me.internalDataSource[i];
            me.resetExpand(item, true);

            if (expandLv2 && Array.isArray(item.childNodes) && item.childNodes.length > 0) {
              expandLv2 = false;
              const lv2 = item.childNodes[0];
              me.resetExpand(lv2, true);
            }
          }
        }
      } else {
        const filterData = me.filterData(queryString);
        const processed = {};
        let roots = [];

        // thêm cha vào để build cây
        const fnItem = function (item) {
          const id = item[me.idProperty];
          if (processed.hasOwnProperty(item[id])) {
            return;
          }
          processed[id] = item;

          delete item.expanded;
          delete item.childNodes;
          delete item.isParent;

          let child = item;
          let pid = child[me.parentIdProperty];
          let pa = item;
          while (pid) {
            const temp = me._parents[pid];
            if (!temp) {
              break;
            }

            pa = processed[pid];
            if (!pa) {
              pa = {...temp};
              pa.childNodes = [];
              processed[pid] = pa;
            } else if (pa.childNodes) {
              for (let i = 0; i < pa.childNodes.length; i++) {
                const node = pa.childNodes[i];
                if (child[me.idProperty] === node[me.idProperty]) {
                  // node.expanded = true;
                  return;
                }
              }
            }

            pa.expanded = true;
            pa.isParent = true;
            pa.childNodes = pa.childNodes || [];
            pa.childNodes.push(child);

            // prv
            child = pa;
            pid = pa[me.parentIdProperty];
          }

          if (pa) {
            let exist = false;
            for (let i = 0; i < roots.length; i++) {
              if (pa[me.idProperty] === roots[i][me.idProperty]) {
                exist = true;
                break;
              }
            }

            if (!exist) {
              roots.push(pa);
            }
          }
        };

        for (let i = 0; i < filterData.length; i++) {
          const item = {...filterData[i]};
          fnItem(item);
        }

        // sắp xếp lại cho đúng thứ tự
        if (roots.length > 1) {
          const fnOrder = function (items) {
            const rs = items.sortObject('_ix');
            for (let i = 0; i < rs.length; i++) {
              if (Array.isArray(rs[i].childNodes) && rs[i].childNodes.length > 0) {
                fnOrder(rs[i].childNodes);
              }
            }
            return rs;
          };
          roots = fnOrder(roots);
        }

        me.internalDataSource = roots;
        me.createDisplayMap();
      }

      // if (me.internalSelectedItem) {
      //   me.appendData([me.internalSelectedItem], true);
      // }
    },

    /**
     * Tạo map node từ data source
     */
    createDisplayMap() {
      const me = this;
      const map = {};
      const fn = function (items, parentId) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          map[item[me.valueField]] = item;
          if (Array.isArray(item.childNodes) && item.childNodes.length > 0) {
            fn(item.childNodes);
          }
        }
      };

      fn(me.internalDataSource);
      me._sourceMap = map;
    },

    /**
     * Expand tất cả các node
     */
    expandAllNode(items = this.internalDataSource) {
      if (!Array.isArray(items)) {
        return;
      }
      const me = this;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        me.resetExpand(item, true);
        if (Array.isArray(item.childNodes) && item.childNodes.length > 0) {
          me.expandAllNode(item.childNodes);
        }
      }
    },

    resetExpand(item, expand) {
      const me = this;
      item.expanded = expand;
      if (item.childNodes && item.childNodes.length > 0) {
        for (let i = 0; i < item.childNodes.length; i++) {
          const child = item.childNodes[i];
          me.resetExpand(child, false);
        }
      }
    },

    filterData(queryString) {
      const me = this;
      let matchItem = [];

      if (queryString) {
        me._allData.forEach(item => {
          let valid = false;
          for (const f in me.filterFields) {
            const value = item[f];
            const test = me.testFilter(me.filterFields[f], value, queryString);
            if (test) {
              valid = true;
              break;
            }
          }

          if (valid) {
            matchItem.push(item);
          }
        });
      } else {
        matchItem = me._allData;
      }

      return matchItem;
    },

    /**
     * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
     * CreatedBy LTDAT 11/12/2019
     */
    getQueryString() {
      return (this.internalText || '').trim();
    },
    // Click ra ngoài combo đóng combo lại
    // Created by LTDAT 18.06.2020
    click_out(e) {
      const me = this;
      if (
        !commonFn.hasParent(e.target, me.$el) &&
        me.$refs.dropdownPanel &&
        me.$refs.dropdownPanel.$el &&
        !commonFn.hasParent(e.target, me.$refs.dropdownPanel.$el)
      ) {
        me.collapse();
      }
    },
    // Reset lại các giá trị trong combobox
    reset() {
      const me = this;
      me.internalText = '';
      me.internalSelectedItem = null;
      // me.typeAheadPointer = -1;
      me.internalValue = null;
      me.$emit('update:modelValue', me.internalValue);
      me.$emit('update:display', '');
    },
    /**
     * Set giá trị hiển thị
     * @pram value giá trị hiển thị
     */
    setInternalText(value) {
      const me = this;
      me.internalText = value;
    },
    /**
     * Set value cho combo
     */
    setValue(value, userAction = false) {
      const me = this;
      me.internalValue = value;
      me.$emit('update:modelValue', me.internalValue);
      // me.doHightlightItem();
      // if (me.typeAheadPointer >= 0) {
      //   me.setInternalItem(
      //     me.internalDataSource[me.typeAheadPointer],
      //     userAction
      //   );
      // }
    },
    // Sự kiện nhập liệu trên input
    // Created by LTDAT (16.06.2020)
    onInput() {
      const me = this;

      me._typing = true;
      if (!me.expanded) {
        me.expand();
        // me.doQueryInternal(me.getQueryString(), true);
      }

      if (!me.internalText) {
        const metaData = {
          oldData: me.internalSelectedItem,
          newData: null,
        };
        me.$emit('selected', metaData);
        me.reset();
      }

      me.doQuery(me.internalText, true);
      me._typing = false;
      if (!me.forceSelection && me.valueField == me.displayField) {
        me.internalValue = me.internalText;
        me.$emit('update:modelValue', me.internalValue);
      }
      // me.doHightlightItem(true);
      // me.adjustScroll();
    },
    // Sự kiện click vào input
    // Created by NNLAM (19/04/2021)
    onClick(e) {
      this.$emit('click', e);
    },
    // Sự kiện focus vào input
    // Created by LTDAT (16.06.2020)
    onFocus(e) {
      const me = this;
      me.focused = true;
      e.target.select();
    },
    // Sự kiện change input
    // Created by LTDAT (16.06.2020)
    // Tạm rem hàm này, chưa hiểu làm gì
    onChange() {
      const me = this;
      if (me.focused) {
        if (me.forceSelection) {
          // search comboboxtree, click item reset get value new
          if (me.typeAheadPointer < 0 && me.internalValue == null) {
            me.reset();
          }
        }
      }
      // if (me.focused) {
      //   if (me.forceSelection) {
      //     if (me.typeAheadPointer < 0) {
      //       //me.reset();
      //       // let dataEmpty = {};
      //       //   dataEmpty[me.valueField] = null;
      //       //   dataEmpty[me.displayField] = me.internalText;
      //       //   let metaData = {
      //       //     oldData: me.internalSelectedItem,
      //       //     newData: dataEmpty,
      //       //     userAction: false
      //       //   };
      //       //TODO bnduc 9.7.2021: Bỏ raise selectd event đi vì các form đang handle để gán lại initText -> lỗi validate forceSelection
      //       // me.$emit("selected", metaData);
      //       me.$emit('update:modelValue', me.internalValue);
      //     } else {
      //       me.typeAheadPointer = me.filterIndexItemByText();
      //     }
      //   } else {
      //     if (me.valueField == me.displayField) {
      //       me.internalValue = me.internalText;
      //       me.$emit('update:modelValue', me.internalValue);
      //     } else {
      //       me.typeAheadPointer = me.filterIndexItemByText();
      //       if (me.typeAheadPointer < 0) {
      //         me.internalValue = null;
      //         let dataEmpty = {};
      //         dataEmpty[me.valueField] = null;
      //         dataEmpty[me.displayField] = me.internalText;
      //         let metaData = {
      //           oldData: me.internalSelectedItem,
      //           newData: dataEmpty,
      //           userAction: false,
      //         };
      //         me.$emit('selected', metaData);
      //         me.$emit('update:modelValue', me.internalValue);
      //       }
      //     }
      //   }
      // }
    },
    // Sự kiện blur input
    // Created by LTDAT (16.06.2020)
    // pvduy 07/05/2021: sửa lại combobox (đã trao đổi với SA anh BNDuc)
    onBlur(e) {
      const me = this;
      me.focused = false;

      me.$nextTick(() => {
        if (!me.focused) {
          // nếu không có value mà source chỉ có 1 bản ghi + text hiển thị đang map -> select item này
          if (me.internalDataSource.length === 1 && me.internalText && !me.internalValue) {
            const firstItem = me.internalDataSource[0];
            me.setInternalItem(firstItem);
          }

          me.validateBlur();

          me.$emit('blur', e);
        }
      });
    },
    // Sự kiện keydown input
    // Created by LTDAT (16.06.2020)
    onKeydown(e) {
      const me = this;
      //e.stopPropagation();

      switch (e.which) {
        case 40: // arrow down
          me.downKeyAction(e);
          break;
        case 38: // arrow up
          me.prevKeyAction(e);
          break;
        case 39: // arrow right
          me.rightKeyAction(e);
          break;
        case 37: // arrow left
          me.leftKeyAction(e);
          break;
        case 13: // enter
          me.enterKeyAction(e);
          break;
        case 9: // tab
          me.tabKeyAction(e);
          break;
      }
      me.$emit(this.$ms.constant.CustomEvent.MsKeydown, e);
      // me.$emit('MsKeydown', e);
    },
    /**
     * Xử lý phím enter
     */
    tabKeyAction() {
      const me = this;
      if (me.activeItem && me.internalText) {
        const node = me._nodes[me.activeItem[me.valueField]];
        me.setInternalItem(node);
      }

      me.collapse();
    },
    /**
     * Xử lý phím enter
     */
    enterKeyAction() {
      const me = this;
      if (me.activeItem) {
        const node = me._nodes[me.activeItem[me.valueField]];
        me.setInternalItem(node);
      }

      me.collapse();
    },
    /**
     * Xử lý phím phải
     */
    rightKeyAction(e) {
      const me = this;
      if (!me.expanded || !me.activeItem) {
        return;
      }
      stopEvent(e);

      if (Array.isArray(me.activeItem.childNodes) && me.activeItem.childNodes.length > 0) {
        me.activeItem.expanded = true;
        return;
      }
    },
    /**
     * Xử lý phím trái
     */
    leftKeyAction(e) {
      const me = this;
      if (!me.expanded || !me.activeItem) {
        return;
      }
      stopEvent(e);

      // xử lý collapse node expand, nếu node không phải cha thì ref vào node cha gần nhất
      if (me.activeItem.expanded && Array.isArray(me.activeItem.childNodes) && me.activeItem.childNodes.length > 0) {
        const id = me.activeItem[me.valueField];
        const node = me.findNodeById(id);
        if (node) {
          node.expanded = false;
        }
        return;
      }

      const pid = me.activeItem.ParentId;
      if (pid) {
        const parent = me.findNodeById(pid);
        me.setActive(parent);
      }
    },

    /**
     * Xử lý phím up, active bản ghi trước đó
     */
    prevKeyAction(e) {
      const me = this;
      if (!me.expanded) {
        return;
      }

      stopEvent(e);

      // nếu không có bản ghi nào thi không làm gì
      if (!me.activeItem) {
        return;
      }

      // xử lý active con cuối cùng và sâu nhất đang expanded
      const activeFn = function (item) {
        if (item.expanded && Array.isArray(item.childNodes) && item.childNodes.length > 0) {
          activeFn(item.childNodes[item.childNodes.length - 1]);
        } else {
          me.setActive(item);
        }
      };

      const prevFn = function (item, items) {
        const cValue = item[me.valueField];
        const count = items.length;
        for (let i = 0; i < count; i++) {
          if (items[i][me.valueField] == cValue) {
            if (i === 0) {
              return false;
            }
            activeFn(items[i - 1]);
            return true;
          }
        }

        return false;
      };

      const pid = me.activeItem.ParentId;
      if (pid) {
        const parent = me.findNodeById(pid);
        const res = prevFn(me.activeItem, parent.childNodes);
        if (!res) {
          me.setActive(parent);
        }
      } else {
        // root
        prevFn(me.activeItem, me.internalDataSource);
      }
    },

    /**
     * Xử lý phím down, active bản ghi tiếp theo
     */
    downKeyAction(e) {
      const me = this;
      stopEvent(e);

      if (!me.expanded) {
        // Thêm expand khi thực hiện query dữ liệu mới
        me.expanded = true;
        me.doQueryInternal(null, true);
        return;
      }

      const source = me.internalDataSource;
      // nếu chưa có thì lấy bản ghi đầu tiên
      if (!me.activeItem) {
        if (Array.isArray(source) && source.length > 0) {
          me.setActive(source[0]);
        }
      } else {
        if (
          me.activeItem.isParent &&
          me.activeItem.expanded &&
          Array.isArray(me.activeItem.childNodes) &&
          me.activeItem.childNodes.length > 0
        ) {
          // active first child
          me.setActive(me.activeItem.childNodes[0]);
        } else {
          const nextFn = function (item, items) {
            const cValue = item[me.valueField];
            const count = items.length - 1;
            for (let i = 0; i < count; i++) {
              if (items[i][me.valueField] == cValue) {
                me.setActive(items[i + 1]);
                return true;
              }
            }

            return false;
          };

          const parentFn = function (item) {
            const pid = item.ParentId;
            if (pid) {
              const parent = me.findNodeById(pid);
              const rs = nextFn(item, parent.childNodes);
              if (!rs) {
                // node đứng cuối trong các con -> nhảy ra level ngoài
                parentFn(parent);
              }
            } else {
              // next root
              nextFn(item, source);
            }
          };

          parentFn(me.activeItem);
        }
      }
    },

    /**
     * Tìm node hiển thị theo id
     */
    findNodeById(id) {
      const me = this;
      const source = me._sourceMap || me._nodes;
      return source[id];
    },

    // Lấy tổng số lượng dữ liệu trong data
    getTotalData() {
      const me = this;
      return me.internalDataSource.length;
    },
    // Tìm kiếm item trong list
    // Created by LTDAT(16.06.2020)
    filterIndexItemByText(queryText) {
      const me = this;
      const filters = me.filterFields;
      let value = queryText || me.internalText;
      let index = -1;
      if (filters && value) {
        value = value.toString();
        index = me.internalDataSource.findIndex((item, _index) => {
          let ret = false;
          for (const key in filters) {
            if (filters.hasOwnProperty(key)) {
              const s = filters[key];
              if (s == me.$ms.constant.FilterOperator.Contains) {
                ret =
                  item[key] && item[key].toString() && item[key].toString().toLowerCase().contains(value.toLowerCase());
              } else {
                ret =
                  item[key] &&
                  item[key].toString() &&
                  item[key].toString().toLowerCase().startsWith(value.toLowerCase());
              }
              if (ret) {
                break;
              }
            }
          }
          return ret;
        });
      }
      return index;
    },
    // Lấy cột filter để tìm kiếm local
    // Created by LTDAT 16.06.2020
    getFilterFields() {
      const filter = {};
      const me = this;
      if (this.columns && this.columns.length > 0) {
        for (let i = 0; i < this.columns.length; i++) {
          const col = this.columns[i];
          if (!col.filterOperator) {
            col.filterOperator = me.$ms.constant.FilterOperator.Contains;
          }
          if (col.dataField && col.filterOperator) {
            if (this.filterColumns && this.filterColumns.length > 0) {
              this.filterColumns.forEach(e => {
                if (!filter.hasOwnProperty(e)) {
                  filter[e] = col.filterOperator;
                }
              });
            } else {
              filter[col.dataField] = col.filterOperator;
            }
          }
        }
      } else {
        filter[this.displayField] = me.$ms.constant.FilterOperator.Contains;
      }
      return filter;
    },
    // Lấy element scroll
    // Created by LTDAT (16.06.2020)
    getScroller() {
      if (this.expanded) {
        // return this.$refs["scroller"];
        const dd = this.$refs['dropdownPanel'];
        if (dd && dd.$el && typeof dd.$el.querySelector === 'function') {
          return dd.$el.querySelector('.scroller');
        }
      }
      return null;
    },
    // /**
    //  * Di chuyển view đến bản ghi nếu cần
    //  * @param {Bản ghi cần view} index
    //  * CreatedBy LTDAT 16.06.2020
    //  */
    // adjustScroll(typeAheadPointer = this.typeAheadPointer) {
    //   let scroller = this.getScroller();
    //   if (scroller && typeAheadPointer > 0) {
    //     // scroller.scrollToItem(typeAheadPointer, true);
    //     scroller.scrollTop = 29 * typeAheadPointer;
    //   }
    // },
    // onScrollerVisible() {
    //   const me = this;
    //   // me.adjustScroll();
    // },
    // Hàm xử lý khi chọn item trên dropdown
    // Created by LTDAT(16.06.2020)
    onItemClick(item, event) {
      const me = this;
      event.preventDefault();
      if (me.notSelectionParent && item.isParent) {
        item.expanded = !item.expanded;
      } else {
        me.activeItem = item;
        me.setInternalItem(item);
        me.collapse();
        me.$refs.input.focus();
      }
    },
    // Set giá trị được chọn
    setInternalItem(item) {
      const me = this;
      if (item) {
        if (me.notSelectionParent && item.isParent) {
          return;
        } else if (
          !me.internalSelectedItem ||
          me.internalSelectedItem[me.valueField] !== item[me.valueField] ||
          me.internalSelectedItem[me.valueField] !== me.internalValue
        ) {
          // Lưu lại thông tin old item
          const oldItems = {};
          oldItems[me.valueField] = me.internalValue;
          oldItems[me.displayField] = me.internalText;
          me.internalSelectedItem = item;
          me.internalValue = item[me.valueField];
          me.$emit('update:modelValue', me.internalValue);

          // nddat1 - 08/10/2024: Trường hợp có suffix thì view mang lên cả suffix
          if (me.suffixDisplayField) {
            me.internalText = `${item[me.suffixDisplayField]} ${me.seperateChar} ${item[me.displayField]}`;
            me.$emit('update:suffixDisplay', item[me.suffixDisplayField]);
          } else {
            me.internalText = item[me.displayField];
          }

          // me.typeAheadPointer = me.findIndexItem(item);
          me.$emit('update:display', me.internalText);

          const metaData = {
            oldData: oldItems,
            newData: item,
          };
          me.$emit('selected', metaData);
          me.$emit('change', item[me.valueField], oldItems[me.valueField]);
        }
        // me.collapse();
      }
    },
    // Tìm vị trị của item trong data
    findIndexItem(item) {
      const me = this;
      return me.internalDataSource.findIndex(_item => {
        return _item == item;
      });
    },
    // Khởi tạo dữ liệu tĩnh mặc định
    initStaticData() {
      const me = this;

      me.internalQueryDelay = 200;
      me.filterFields = me.getFilterFields();
      me.internalValue = null;
      me.firstExpand = true;
    },
    /**
     * thêm bản ghi chọn tất cả vào source
     */
    appendSelectAllItem(data) {
      const me = this;
      if (!me.showSelectAll) {
        return;
      }
      const firstItem = data[0];
      if (firstItem && firstItem[me.valueField] !== me.selectAllValue) {
        const allItem = {};
        allItem[me.valueField] = me.selectAllValue;
        allItem[me.displayField] = me._selectAllText;

        // vvkiet - 24.06.2021: Bổ sung text Tất cả cho tất cả các cột
        me.columns.forEach(column => {
          allItem[column.dataField] = me._selectAllText;
        });

        data.unshift(allItem);
      }
    },
    // //append và check đã tồn tại chưa
    // appendData(data, appendHead = false) {
    //   const dataQuery =
    //     this.queryMode === 'remote' ? this.internalDataSource : this._allData;
    //   const validData = data.filter(
    //     (x) => !dataQuery.some((y) => y[this.valueField] === x[this.valueField])
    //   );
    //   appendHead
    //     ? this.internalDataSource.unshift(...validData)
    //     : this.internalDataSource.append(validData);
    // },
    /**
     * Khởi tạo dữ liệu combobox tree
     */
    initData() {
      const me = this;

      // me.internalDataSource = _.cloneDeep(me.data);
      const dataTree = me.nomalizeDataTree(me.data, me.idProperty || me.valueField, me.parentIdProperty);
      me.appendSelectAllItem(dataTree);

      if (me.keyField && me.keyField !== me.valueField) {
        commonFn.genVKeyValue(me.internalDataSource, me.keyField);
      }

      me._allTreeData = dataTree;
      const treeData = commonFn.getBodyData(dataTree);
      if (treeData.length > 0) {
        me.internalDataSource = me._allData = treeData;
        me.doLocalQuery(me.lastQueryString);
      } else {
        me.internalDataSource = [];
        me._allData = null;
      }
    },

    /**
     * Chuyển dữ liệu thành dạng tree
     */
    nomalizeDataTree(data, idField, parentField) {
      const me = this;
      const dataTemp = [...data];
      const parentNodes = [];
      const parents = {};
      const allMap = {};
      const findParent = function (pid) {
        if (!parents.hasOwnProperty(pid)) {
          const parent = _.find(dataTemp, o => {
            return o[idField] === pid;
          });
          parents[pid] = parent;
        }

        return parents[pid];
      };

      for (let i = 0; i < dataTemp.length; i++) {
        const item = dataTemp[i];

        allMap[item[me.valueField]] = item;

        // đánh dấu luôn vị trí tương đối, sau này dùng để sắp xếp lại dữ liệu khi filter
        item._ix = i;

        const pid = item[parentField];
        if (pid) {
          // Tìm cha
          const parent = findParent(pid);
          if (parent) {
            // item.parentNode = parent;
            if (!parent.hasOwnProperty('childNodes')) {
              parent['childNodes'] = [];
            }
            if (!parent.hasOwnProperty('isParent')) {
              parent['isParent'] = true;
            }
            parent.childNodes.push(item);
            item.ParentId = parent[me.valueField];
          } else {
            parentNodes.push(item);
          }
        } else {
          // NMSINH: thêm món này vì nếu chọn thằng ko có Cha trong list thì nó chính là cha luôn
          parentNodes.push(item);
        }
      }

      me._nodes = allMap;
      me._parents = parents;
      return parentNodes;
    },

    /**
     * click vào icon dropdown
     */
    triggerClick(e) {
      const me = this;
      const expanded = me.expanded;

      // disable thì không làm gì
      if (me.disabled) {
        return;
      }

      if (!expanded) {
        // if (me.pagination) {
        me.doQueryInternal(null, true);
        // } else if (me.firstExpand) {
        //   me.firstExpand = false;

        //   me.doQueryInternal(null, true);
        // }

        // vvkeit - 06.04.2021: 89823 - Lỗi chung: Lỗi trên form điều chuyển hàng loạt dưới bảng chi tiết khi đã chọn tài sản thì đang không xổ combo để chọn tiếp
        // me.$refs.input.focus();
        me.changeDropdownPosition();
        // me.doHightlightItem();
      }

      // đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = !expanded;
      });

      // focus input
      me.$refs.input.focus();
    },

    /**
     * hiển thị dropdown
     */
    expand() {
      const me = this;

      me.$emit('beforeExpand');
      // vvkeit - 06.04.2021: 89823 - Lỗi chung: Lỗi trên form điều chuyển hàng loạt dưới bảng chi tiết khi đã chọn tài sản thì đang không xổ combo để chọn tiếp
      // me.$refs.input.focus();
      me.changeDropdownPosition();
      // me.doHightlightItem();

      // đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = true;

        // active vào bản ghi selected
        me.activeOnExpand();
      });
    },
    /**
     * active bản ghi khi expand và đảm bảo mở rộng đường dẫn đến node được chọn
     */
    activeOnExpand() {
      const me = this;

      // reset
      me.activeItem = null;

      // Ưu tiên sử dụng firstData nếu có
      if (me.firstData) {
        // Chỉ mở rộng các node cha liên quan đến node được chọn
        me.expandPathToNode(me.firstData);
        me.setActive(me.firstData);
        return;
      }

      // active selected value
      if (me.modelValue) {
        const selected = me._nodes[me.modelValue];
        if (selected) {
          // Chỉ mở rộng các node cha liên quan đến node được chọn
          me.expandPathToNode(selected);
          me.setActive(selected);
          return;
        }
      }

      // active bản ghi đầu tiên
      if (Array.isArray(me._allTreeData) && me._allTreeData.length > 0) {
        me.setActive(me._allTreeData[0]);
      }
    },

    /**
     * Mở rộng các node cha của node cần focus
     */
    expandPathToNode(targetNode) {
      const me = this;
      if (!targetNode) return;

      // Bắt đầu từ node cần focus, tìm và mở rộng các node cha
      let currentNode = targetNode;

      while (currentNode && currentNode.ParentId) {
        const parentNode = me.findNodeById(currentNode.ParentId);
        if (parentNode) {
          // Chỉ mở rộng node cha, không mở rộng các node khác
          parentNode.expanded = true;
          currentNode = parentNode;
        } else {
          break;
        }
      }
    },
    /**
     * ẩn dropdown
     */
    collapse() {
      const me = this;
      me.$nextTick(() => {
        me.expanded = false;
      });
    },
    /**
     * Hàm set vị trí cho dropdown menu khi expand
     * TODO: Chưa xử lý khi có scroll
     */
    changeDropdownPosition() {
      const me = this;
      let comboEl = me.$el;

      if (comboEl) {
        comboEl = comboEl.getElementsByClassName('combo-box-input')[0];
      }
      if (comboEl) {
        const comboElRect = comboEl.getBoundingClientRect();
        const comboMenuEl = me.$el;

        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        me.dropdownLeftx = comboElRect.left;
        me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth ? me.dropdownWidth : comboElRect.width;

        // Nếu chạm phải thì align sang trái
        if (comboElRect.left + me.dropdownMaxWidthx > windowWidth) {
          me.dropdownLeftx = comboElRect.right - me.dropdownMaxWidthx;
        }

        // nếu trước đó đã tính -> giữ nguyên, đợi render xong hiển thị dropdown sẽ tính lại sau
        if (!me.dropdownTopx) {
          me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
        }

        me.$nextTick(() => {
          setTimeout(() => {
            const dd = me.$refs.dropdownPanel;
            if (dd && dd.$el) {
              const ofs = dd.$el.getBoundingClientRect();
              if (comboElRect.top + comboElRect.height + ofs.height + 10 > windowHeight) {
                // quay lên trên
                me.dropdownTopx = comboElRect.top - ofs.height - 2;
              } else {
                me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
              }
            }
          }, 0);
        });
      }
    },
    /**
     * Click vào icon quicksearch
     */
    quickSearchClick(e) {
      const me = this;
      e.preventDefault();
      if (me.quickSearch) {
        if (me.disabled) {
          return;
        }
        me.expanded = false;

        const param = {...(me.quickSearchParam || {})};

        popupUtil.show(
          me.quickSearch,
          Object.assign(param, {
            /**
             * Sự kiện callback khi chọn item từ form tìm nhanh
             */
            submit: me.callbackAddData,
            close: function () {
              me.$refs.input.focus();
            },
          }),
        );
      }
    },

    callbackAddData(record) {
      const me = this;
      let notExistArr = [];
      const checkingData = me._allData ? me._allData : me.internalDataSource;
      if (Array.isArray(record)) {
        notExistArr = record.filter(x => !checkingData.some(y => y[me.valueField] === x[me.valueField]));

        me.setInternalItem(record[0]);
      } else {
        notExistArr = checkingData.filter(i => i[me.valueField] !== record[me.valueField]);

        me.setInternalItem(record);
      }
      // me.$nextTick(() => {
      //   me.validate(me);
      // });

      me.$refs.input.focus();
      // me.internalDataSource.unshift(...notExistArr);

      // if (me.existAdded && notExistArr[0]) {
      //   me.existAdded.push(notExistArr[0][me.valueField]);
      // } else {
      //   me.existAdded = [notExistArr[0][me.valueField]];
      // }
      me.$emit('submitQuickAdd', notExistArr);
    },
    /**
     * Validate khi blur
     * ntnghia - 11/03/2021
     * bnduc 21.6.2021: Đổi lại thành gọi hàm validate của control thay vì viết scustom như này
     */
    validateBlur() {
      // TODO Tạm thời xóa validate do chưa kiểm soát được
      this.validate(this);
    },
    /**
     * xử lý phím esc
     */
    onEsc(e) {
      const me = this;

      // ẩn dropdown và stop event nếu đang expand
      if (me.expanded) {
        me.collapse();
        e.preventDefault();
        e.cancel = true;
      }
    },

    /**
     * xử lý phím enter
     */
    onEnter(e) {
      const me = this;

      if (me.expanded && !me.loading && me.internalDataSource.length === 0) {
        e.preventDefault();
        e.stopPropagation();
        me.showQuickAdd(true);
      }
    },

    /**
     * Mở form thêm nhanh
     */
    showQuickAdd(isfromEnter, isfromShortKey) {
      const me = this;
      if (!me.loading) {
        if (!me.quickAdd) {
          return;
        }
        me.expanded = false;
        const param = {...(me.quickSearchParam || {})};
        param.mode = me.$ms.constant.FormState.Add;
        if (me.internalText) {
          param.quickAddText = me.internalText;
        }

        param.submit = me.callbackAddData;

        // TODO => show popup quick add ở đây
        popupUtil.show(me.quickAdd, param);
      }
    },

    /**
     * @override
     */
    customRuleValidateRules(rules) {
      const me = this;
      me.super('customRuleValidateRules', rules);

      if (me.forceSelection && rules.indexOf('forceSelection')) {
        rules.push('forceSelection');
      }
    },

    /**
     * Xử lý khi expand/collapse item node thì gán activeItem luon
     */
    itemToogleExpand(item, expanded) {
      this.setActive(item);
    },
    /**
     * Gán active
     */
    setActive(item) {
      const me = this;
      me.activeItem = item;

      me.$nextTick(() => {
        const activeEl = me.$refs.dropdownPanel.$el.querySelector('.active');
        if (activeEl && typeof activeEl.scrollIntoViewIfNeeded === 'function') {
          activeEl.scrollIntoViewIfNeeded();
        }

        me.focusInput();
      });
    },

    /**
     * focus input nhập liệu
     */
    focusInput() {
      this.$refs.input.focus();
    },
  },
});
</script>
<style lang="scss">
@import '@/assets/scss/components/MsComboboxTree.scss';
</style>
